
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { DirectSupabaseUpload } from './DirectSupabaseUpload';
import InterviewMedia from '@/components/interview/InterviewMedia';

interface PersonalInfoFieldsProps {
  name: string;
  setName: (value: string) => void;
  title: string;
  setTitle: (value: string) => void;
  company: string;
  setCompany: (value: string) => void;
  photoUrl: string;
  setImageUrl: (url: string) => void;
}

const PersonalInfoFields: React.FC<PersonalInfoFieldsProps> = ({
  name,
  setName,
  title,
  setTitle,
  company,
  setCompany,
  photoUrl,
  setImageUrl
}) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="name">Ditt navn</Label>
        <Input
          id="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Skriv inn ditt navn"
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="title">Din tittel</Label>
        <Input
          id="title"
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Professor, forfatter, CEO etc."
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="company">Arbeidsgiver / Tilhørighet</Label>
        <Input
          id="company"
          type="text"
          value={company}
          onChange={(e) => setCompany(e.target.value)}
          placeholder="Hvis aktuelt"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <DirectSupabaseUpload onImageUploaded={setImageUrl} />
        </div>
        <div>
          <Label>Forhåndsvisning</Label>
          <InterviewMedia photoUrl={photoUrl} intervieweeName={name} />
        </div>
      </div>
    </div>
  );
};

export default PersonalInfoFields;
